import React from 'react';
import { ReactComponent } from 'Common/components/Icons/foot-protection.svg';

const FootProtection = () => <ReactComponent className="MuiSvgIcon-root" />;

export default FootProtection;
